import { Trans } from '@lingui/react'
import * as React from 'react'

import nowLogo from 'views/assets/images/logos/logo-now.svg'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import 'views/components/molecules/ImageWithDiscountBadge/ImageWithDiscountBadge.scss'
import 'views/components/organisms/ProductImage/ProductImage.scss'
import './NowNotAvailableBox.scss'
import { NOW_FAQ_MODAL_ID } from 'views/components/organisms/NowFaqModal/names'

const NowNotAvailableBox: React.FunctionComponent = (): React.ReactElement => {
  return (
    <div className="l-flex l-content m-NotAvailableBox">
      <div>
        <img src={nowLogo} alt="NOW! Not Available" />
      </div>
      <div>
        <span className="m-NotAvailableTitle">
          <Trans id="general.label.now.notAvailable" />
        </span>
        <p>
          <Trans
            id="general.label.nowSerp.notAvailable"
            components={[
              <ButtonAsLink
                underlined
                inheritColor
                data-a11y-dialog-show={NOW_FAQ_MODAL_ID}
                type="button"
              >
                <span />
              </ButtonAsLink>,
            ]}
          />
        </p>
      </div>
    </div>
  )
}

export default NowNotAvailableBox
